/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { SxProps, Theme } from "@mui/material";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import getNavigationLinks from "@/src/services/productStatus/getNavigationLinks";
import useCheckProductDeletable from "@/src/hooks/useCheckProductDeletable";
import PageNavigation from "@/src/components/Navigation/SummaryNavigation/PageNavigation";

export type ProductStatusNavigationLinksProps = {
  product: AbstractCase;
  sx?: SxProps<Theme>;
};
export default function ProductStatusNavigationLinks({ product, sx }: ProductStatusNavigationLinksProps) {
  const { data: productIsDeletable } = useCheckProductDeletable(product);

  const navigationLinks = getNavigationLinks(product, productIsDeletable);

  if (!navigationLinks.length) {
    return null;
  }

  return <PageNavigation navigationLinks={navigationLinks} sx={sx} />;
}
